module.exports = __webpack_public_path__ + "img/INF-i-2-III.91ca10e8.png";